import { LoanApplication } from "../contexts";
import { LoanProductType } from "../hooks/api/types";

/**
 * Returns the loan-type-specific input/config object for a given loan application.
 * Used for displaying duration, amount, discount rate, etc. in dashboard and payment schedule.
 */
export function getLoanInputFromApplication(
  loan: LoanApplication | null | undefined
) {
  if (!loan?.loanType) return undefined;
  switch (loan.loanType) {
    case LoanProductType.FIXED_TERM:
      return loan?.fixedTermLoan;
    case LoanProductType.INVOICE_DISCOUNTING:
      return loan?.invoiceDiscountingLoan?.invoices?.[0];
    case LoanProductType.PAYABLE_FINANCING:
      return loan?.payableFinancingLoan?.invoices?.[0];
    case LoanProductType.REVENUE_BASED_FINANCING:
      return loan?.revenueBasedLoan;
    case LoanProductType.POS_REVENUE_BASED_FINANCING:
      return loan?.posRevenueBasedLoan;
    case LoanProductType.BNPL:
      return loan?.buyNowPayLaterLoan;
    case LoanProductType.LOC_INVOICE_DISCOUNTING:
    case LoanProductType.LOC_PAYABLE_FINANCING:
      return loan?.creditLine;
    default:
      return undefined;
  }
}
